module.exports = __webpack_public_path__ + "media/images/values/nice-3fe53f2468b57376d9c72c26fa0c6609.svg";